// extracted by mini-css-extract-plugin
export default {"modal":"EditTermModal__modal___Orv29"};